<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal" ref="loader"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
            color="green darken-1"
            flat="flat"
            @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <v-form v-model="valid" ref="form" lazy-validation>
      <table class="proComponent">
        <tbody>
          <tr>
            <th rowspan="2">Source</th>
            <th colspan="2">ADP (Technical Assistance)</th>
            <th colspan="2">NON-ADP (On lending)</th>
            <th colspan="2">Total</th>
          </tr>
          <tr>
            <th>USD (Million)</th>
            <th>BDT (Lac)</th>
            <th>USD (Million)</th>
            <th>BDT (Lac)</th>
            <th>USD (Million)</th>
            <th>BDT (Lac)</th>
          </tr>
          <tr>
            <th>IDA</th>
            <td>
              <v-text-field solo box v-model="formSchema.ida_adp_usd" :rules="[decimalShort]"
              @input="SumValues('ida_adp_usd','gob_adp_usd','adp_usd_total')">
              </v-text-field>
            </td>
            <td>
              <v-text-field solo box v-model="formSchema.ida_adp_bdt"  :rules="[decimalShort]"
              @input="SumValues('ida_adp_bdt','gob_adp_bdt','adp_bdt_total')"
              ></v-text-field>
            </td>

            <td>
              <v-text-field solo box v-model="formSchema.ida_non_adp_usd" :rules="[decimalShort]"
              @input="SumValues('ida_non_adp_usd','gob_non_adp_usd','non_adp_usd_total')"
              ></v-text-field>
            </td>
            <td>
              <v-text-field solo box v-model="formSchema.ida_non_adp_bdt" :rules="[decimalShort]"
              @input="SumValues('ida_non_adp_bdt','gob_non_adp_bdt','non_adp_bdt_total')"
              ></v-text-field>
            </td>

            <td>
              <v-text-field solo box v-model="formSchema.ida_usd_total" readonly></v-text-field>
            </td>
            <td>
              <v-text-field solo box v-model="formSchema.ida_bdt_total" readonly></v-text-field>
            </td>

          </tr>
          <tr>
            <th>GOB</th>
            <td>
              <v-text-field solo box v-model="formSchema.gob_adp_usd" :rules="[decimalShort]"
              @input="SumValues('ida_adp_usd','gob_adp_usd','adp_usd_total')"
              ></v-text-field>
            </td>
            <td>
              <v-text-field solo box v-model="formSchema.gob_adp_bdt" :rules="[decimalShort]"
              @input="SumValues('ida_adp_bdt','gob_adp_bdt','adp_bdt_total')"
              ></v-text-field>
            </td>

            <td>
              <v-text-field solo box v-model="formSchema.gob_non_adp_usd" :rules="[decimalShort]"
              @input="SumValues('ida_non_adp_usd','gob_non_adp_usd','non_adp_usd_total')"
              ></v-text-field>
            </td>
            <td>
              <v-text-field solo box v-model="formSchema.gob_non_adp_bdt" :rules="[decimalShort]"
              @input="SumValues('ida_non_adp_bdt','gob_non_adp_bdt','non_adp_bdt_total')"
              ></v-text-field>
            </td>

            <td>
              <v-text-field solo box v-model="formSchema.gob_usd_total" readonly></v-text-field>
            </td>
            <td>
              <v-text-field solo box v-model="formSchema.gob_bdt_total" readonly></v-text-field>
            </td>
          </tr>
          <tr>
            <th>Total</th>
            <td>
              <v-text-field solo box v-model="formSchema.adp_usd_total" readonly></v-text-field>
            </td>
            <td>
              <v-text-field solo box v-model="formSchema.adp_bdt_total" readonly></v-text-field>
            </td>
            <td>
              <v-text-field solo box v-model="formSchema.non_adp_usd_total" readonly></v-text-field>
            </td>
            <td>
              <v-text-field solo box v-model="formSchema.non_adp_bdt_total" readonly></v-text-field>
            </td>
            <td>
              <v-text-field solo box v-model="formSchema.usd_total" readonly></v-text-field>
            </td>
            <td>
              <v-text-field solo box v-model="formSchema.bdt_total" readonly></v-text-field>
            </td>
          </tr>
        </tbody>
      </table>          
    </v-form>

  <v-card-actions>
    <v-spacer></v-spacer>

    <template v-if="revision>0">
      <v-btn color="primary" @click="checkFormValidation">
        <v-icon>rate_review</v-icon>Revision
      </v-btn>
    </template>
    <template v-else>
      <v-btn color="error" @click="previous">
        <v-icon>arrow_back_ios</v-icon>Previous
      </v-btn>
      <v-btn color="success" @click="checkFormValidation">
        <v-icon>save</v-icon> Save 
      </v-btn>
      <v-btn color="secondary" @click="close">
        <v-icon>refresh</v-icon> Reset          
      </v-btn>        
    </template>
    <v-btn v-if="operation_act_id" color="primary" @click="nextStep">
      Next
      <v-icon>arrow_forward_ios</v-icon>
    </v-btn>
  </v-card-actions>
  
  </div>
</template>

<script>
let commonService = require("../../../../services/common.service");
let utilities = require("../../../../utilities/utilities");
export default {
  data() {
    return {
      valid: true,
      e1: 0,
      revision: null,
      operation_act_id: sessionStorage.getItem("operation_act_id"),

      delete_id: "",
      row_index: "",
      dialog2: false,
      
      SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

      formSchema: {
        id: 0,
        ida_adp_usd:"",
        ida_adp_bdt:"",
        ida_non_adp_usd:"",
        ida_non_adp_bdt:"",
        ida_usd_total:"",
        ida_bdt_total:"",
        gob_adp_usd:"",
        gob_adp_bdt:"",
        gob_non_adp_usd:"",
        gob_non_adp_bdt:"",
        gob_usd_total:"",
        gob_bdt_total:"",
        adp_usd_total:"",
        adp_bdt_total:"",
        non_adp_usd_total:"",
        non_adp_bdt_total:"",
        usd_total:"",
        bdt_total:"",
        revision: "",
      },

      dataList: []
    };
  },

  created() {
    this.revision = sessionStorage.getItem("revision");
    if (sessionStorage.getItem("operation_act_id")) {
      this.loadData();
    }
  },

  methods: {

    SumValues(topField,bottomField, totalField)
    {
      let A = this.formSchema[topField];
      let B = this.formSchema[bottomField];
      let Total = this.formSchema[totalField] = ((parseFloat(A) || 0) + (parseFloat(B)||0)).toFixed(3);


      var formSchema = this.formSchema;
      formSchema.ida_usd_total = this.SumFloatNumber(formSchema.ida_adp_usd, formSchema.ida_non_adp_usd);

      formSchema.ida_bdt_total = this.SumFloatNumber(formSchema.ida_adp_bdt, formSchema.ida_non_adp_bdt);

      formSchema.gob_usd_total =  this.SumFloatNumber(formSchema.gob_adp_usd, formSchema.gob_non_adp_usd);

      formSchema.gob_bdt_total = this.SumFloatNumber(formSchema.gob_adp_bdt, formSchema.gob_non_adp_bdt);

      formSchema.usd_total = this.SumFloatNumber(formSchema.ida_usd_total, formSchema.gob_usd_total);
      formSchema.bdt_total = this.SumFloatNumber(formSchema.ida_bdt_total, formSchema.gob_bdt_total);
    },

    SumFloatNumber(a,b){
      return ((parseFloat(a) || 0) + (parseFloat(b) || 0)).toFixed(3);
    },

    loadData() {
      commonService
      .getAllDataById(this.operation_act_id, "project-components-list")
      .then(res => {
        if (res.status > 0) {
          //this.dataList = (res.data.length>0) ? res.data : [];
          this.formSchema = res.data
        }
      });
    },

    checkFormValidation() {
      if (this.$refs.form.validate()) {
        this.submitForm();
      }
    },

    submitForm() {

      this.$refs.loader.loaderEnabled();

      let formSchema = this.formSchema;
      formSchema.operation_act_id = sessionStorage.getItem("operation_act_id");
      formSchema.revision = (this.revision>0) ? this.revision : null;
      let root = this;
      console.log('formSchema', formSchema);
      commonService
      .insertFormData(formSchema, "project-components")
      .then(res => {

        if (res.status == 1) {
          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;; 

          if (res.action == "add") {
              //this.dataList.unshift({ ...res.data });
              this.loadData();
            }
            if (res.action == "edit") {
              this.$set(this.dataList, this.row_index, { ...res.data });
              this.row_index = "";
            }
            window.scrollTo({
              left: 0,
              top:
              document.body.scrollHeight ||
              document.documentElement.scrollHeight,
              behavior: "smooth"
            });
            this.SnackbarVal.color = "success";
          }
          else
          {
            this.SnackbarVal.message = res.message;
            this.SnackbarVal.snackbar = true;
            this.SnackbarVal.color = "error"
          }

        });
    },

    // getName: function(partnerId) {
    //   return this.deptPartnerList.filter(function(a){ return a.id == partnerId })[0].name
    // },

    nextStep() {
      this.$emit("emitForm4", 4);
    },

    previous() {
      this.$emit("emitForm4", 2);
    },

    editItem(index, item) {
      this.row_index = index;
      this.formSchema = {...item};
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "project-components").then(res => {
        if (res.status == 1) {
          this.dataList.splice(row_index, 1);
          this.SnackbarVal.color = "success"
        }
        else
        {
          this.SnackbarVal.color = "error"
        }
        
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
        
        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close: function() {
      let formSchema = this.formSchema;
      Object.keys(formSchema).forEach(function(key) {
        formSchema[key] = "";
      });
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped>
  .proComponent{
    border-collapse: collapse;
    width: 100%;
  }
  
  .proComponent th{
    padding: 0px 5px;
  }

  .proComponent th,
  .proComponent td{
    border:1px solid #CCC;
    line-height: 50px;
  }
</style>


// WEBPACK FOOTER //
// src/components/project_info/operation_activities/step_forms/projectComponents.vue